import React from 'react';
import Zoom from 'react-medium-image-zoom';

const title = "Journal Report";
const description = `The Journal Report is the book of original entry, providing a detailed, chronological list of every financial transaction before it is posted to the General Ledger accounts. Each entry, known as a journal entry, records the date, the specific accounts to be debited and credited, the respective amounts, and a narrative description. It is the first step in the accounting process, ensuring that the double-entry principle is correctly applied to every transaction, and serves as an essential primary source document for audits.`;

const images = [
    '/images/reports/purchase-by-supplier/purchase-by-supplier.png', // 0
];


const JournalReport: React.FC = () => {

    return (
        <div className="max-w-4xl lg:max-w-5xl min-h-screen bg-gray-50 flex gap-2">
            <div className="overflow-auto mx-auto flex-2">

                <div className="mb-6">
                    <h1 className="text-3xl font-bold pt-4 text-gray-900">
                        {title}
                    </h1>
                    <p className="text-gray-600 mt-4">
                        {description}
                    </p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 my-6">
                        <Zoom>
                            <img
                                src={images[0]}
                                alt={title}
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>
                        </Zoom>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default JournalReport;
